export enum PaymentsStatuses {
  /**
   * Неоплачен
   */
  UNPAID = 'unpaid',

  /**
   * Частично оплачен
   */
  PARTIALLY_PAID = 'pairtially_paid',

  /**
   * Оплачен
   */
  PAID = 'paid',
}

export const PaymentsStatusesTranslate = {
  [PaymentsStatuses.UNPAID]: 'Не оплачен',
  [PaymentsStatuses.PARTIALLY_PAID]: 'Частично',
  [PaymentsStatuses.PAID]: 'Оплачен',
};
